// extracted by mini-css-extract-plugin
export default {"image":"_35d25aa5947a130e","actions":"_2f8f3292e6f6a1c7","button":"_58b83ca5cf699867"};